import { Injectable } from '@angular/core'
import { Role } from './role'

@Injectable()
export class RoleSerializer {
  fromJson(json: any): Role {
    const role = {
      ...json
    }

    return role
  }

  toJson(role: Role): any {
    return {
      ...role
    }
  }
}
